import { useCallback, useEffect, useRef, useState } from 'react';
import CoachingKangaroo from '../../../../api/CoachingKangaroo';

const isAbortError = (error) =>
    error?.code === 'ERR_CANCELED' || error?.name === 'CanceledError';

export const useAnswerContext = (project, answerId, enabled = true) => {
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);
    const [loadError, setLoadError] = useState(null);
    const [retryCount, setRetryCount] = useState(0);
    const requestIdRef = useRef(0);

    const refetch = useCallback(() => {
        setRetryCount((count) => count + 1);
    }, []);

    useEffect(() => {
        if (!enabled || !project || !answerId) {
            return undefined;
        }

        const requestId = ++requestIdRef.current;
        const controller = new AbortController();

        setIsLoading(true);
        setLoadError(null);
        setIsLoaded(false);
        setData([]);

        CoachingKangaroo.get(
            '/api/training/v1/' +
            encodeURIComponent(project) +
            '/context/' +
            encodeURIComponent(answerId),
            { signal: controller.signal }
        )
            .then((response) => {
                if (requestId !== requestIdRef.current) {
                    return;
                }
                setData(Array.isArray(response.data) ? response.data : []);
                setIsLoaded(true);
                setIsLoading(false);
            })
            .catch((error) => {
                if (requestId !== requestIdRef.current || isAbortError(error)) {
                    return;
                }
                setLoadError(error);
                setIsLoading(false);
            });

        return () => {
            requestIdRef.current += 1;
            controller.abort();
        };
    }, [project, answerId, enabled, retryCount]);

    return {
        data,
        isLoading,
        isLoaded,
        loadError,
        refetch,
    };
};
